import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import getGroceriesTabSelected from '@shopDetails/selectors/getGroceriesTabSelected';
import getSectionsList from '@shopDetails/selectors/getSectionsList';
import { getListedInfoData } from '@conversion/tracking/utils';
import { track, logError } from '@tracking';

const EVENT_NAME = 'section_list.expanded';
const trackSectionListExpanded = (pageCounter, prevPageSectionQuantity) => (
  dispatch,
  getState,
) => {
  try {
    const state = getState();
    if (getGroceriesTabSelected(state) !== 1) {
      const sectionsList = getSectionsList(state);
      const shopId = getShopId(state);
      const businessType = getShopBusinessType(state);
      const listedInfo = getListedInfoData(
        sectionsList.slice(prevPageSectionQuantity - 1, sectionsList.length),
      );
      const sectionsTotalQuantity = sectionsList.length;
      const sectionsQuantityShown =
        sectionsTotalQuantity - prevPageSectionQuantity;
      const page = pageCounter;

      const payload = {
        shopId,
        businessType,
        listedInfo,
        sectionsTotalQuantity,
        sectionsQuantityShown,
        page,
      };
      track(EVENT_NAME, payload);
    }
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackSectionListExpanded;
